/* unplugin-vue-components disabled */import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
//
//
//
//

import upload from '@/utils/upload';
import { createWaterMark } from '@/utils/waterMark';
import { baseUrl } from '@root/_target.js';
export default {
  name: 'fileupload',
  props: {
    target: {
      type: String
    },
    action: {
      type: String
    },
    accept: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    capture: {
      type: null
    },
    multiple: {
      type: Boolean,
      default: true
    },
    waterMask: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      file: null
    };
  },
  computed: {
    realtarget: function realtarget() {
      return baseUrl + this.target;
    }
  },
  mounted: function mounted() {
    if (this.multiple) {
      this.$refs.upload.setAttribute('multiple', true);
    }
  },
  methods: {
    upload: function upload() {
      this.$refs.upload.click();
    },
    emitter: function emitter(event, data) {
      this.$emit(event, data);
    },
    updateProgress: function updateProgress(oEvent) {
      var vm = this;
      if (oEvent.lengthComputable) {
        var percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total);
        vm.emitter('progress', percentComplete);
      } else {
        // Unable to compute progress information since the total size is unknown
        vm.emitter('progress', false);
      }
    },
    onFileChange: function onFileChange(event) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vm, files, filesArr, file, uploadFile;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;
                if (!(!_this.target || _this.target === '')) {
                  _context.next = 5;
                  break;
                }
                console.log('Please provide the target url');
                _context.next = 32;
                break;
              case 5:
                if (!(!_this.action || _this.action === '')) {
                  _context.next = 9;
                  break;
                }
                console.log('Please provide file upload action ( POST / PUT )');
                _context.next = 32;
                break;
              case 9:
                if (!(_this.action !== 'POST' && _this.action !== 'PUT')) {
                  _context.next = 13;
                  break;
                }
                console.log('File upload component only allows POST and PUT Actions');
                _context.next = 32;
                break;
              case 13:
                uploadFile = function _uploadFile(file) {
                  var _this2 = this;
                  return new Promise(function (resolve) {
                    upload({
                      action: _this2.action,
                      target: _this2.realtarget,
                      file: file,
                      filename: file.name,
                      onProgress: vm.updateProgress,
                      onStart: function onStart(e) {
                        _this2.emitter('start', e);
                      },
                      onEnd: function onEnd(e) {
                        _this2.emitter('finish', e);
                        resolve(e);
                      }
                    });
                  });
                };
                files = event.target.files || event.dataTransfer.files;
                if (files.length) {
                  _context.next = 17;
                  break;
                }
                return _context.abrupt("return");
              case 17:
                if (!_this.multiple) {
                  _context.next = 26;
                  break;
                }
                filesArr = Array.from(files);
                if (!_this.waterMask) {
                  _context.next = 23;
                  break;
                }
                _context.next = 22;
                return Promise.all(filesArr.map(function (v) {
                  return createWaterMark(v);
                }));
              case 22:
                filesArr = _context.sent;
              case 23:
                Promise.all(filesArr.map(function (file) {
                  return uploadFile.call(_this, file);
                }));
                _context.next = 32;
                break;
              case 26:
                file = files[0];
                if (!_this.waterMask) {
                  _context.next = 31;
                  break;
                }
                _context.next = 30;
                return createWaterMark(file);
              case 30:
                file = _context.sent;
              case 31:
                uploadFile.call(_this, file);
              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};